module.exports = __webpack_public_path__ + "static/media/Lee.57496ec0.png";